module.exports = __webpack_public_path__ + "img/img1.88fdfe5d.jpg";